import { inject } from '@angular/core'
import { signalStore, withMethods } from '@ngrx/signals'
import { ActivatedRoute, Router } from '@angular/router'

export const RouterStore = signalStore(
  { providedIn: 'root' },
  withMethods(() => {
    const router = inject(Router)
    return {
      navigate(path: string, relativeTo?: ActivatedRoute): void {
        router.navigate([path], { relativeTo })
      },
      navigateExternal(path: string): void {
        router.navigate(['/externalRedirect', { externalUrl: path, target: '_self' }])
      },
      navigateToNewTab(path: string): void {
        window.open(path, '_blank')
      },
    }
  }),
)
